import React from 'react';
import i18n from '../../i18n';
import { Box, Typography } from '@mui/material';

export default class DialogSystemRoleField extends React.Component {
    render() {
        const trueLabel = i18n.t(`text.${this.props.field.trueLabel}`);
        const falseLabel = i18n.t(`text.${this.props.field.falseLabel}`);
        const value = this.props.value;
        const mode = this.props.mode;

        if (mode === 'add') return null;

        return (
            <Box ml={1}>
                {value ? (
                    <Typography variant="body2" color="text.secondary">
                        {trueLabel}
                    </Typography>
                ) : (
                    <Typography variant="body2" color="text.secondary">
                        {falseLabel}
                    </Typography>
                )}
            </Box>
        );
    }
}
